import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from "@msdyn365-commerce/retail-proxy";

function setLastSurveyDateQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function setLastSurveyDateInput(lastSurveyDate: Date): IDataServiceRequest {
    const query = setLastSurveyDateQuery();
    return query.createDataServiceRequestForOperation(
        'SetLastSurveyDate',
        true,
        'NullResponseExtensionClass',
        'false',
        { bypassCache: 'get', returnEntity: 'NullResponse' },
        {
            lastSurveyDate: lastSurveyDate
        }
    );
}

export function setLastSurveyDateAsync(context: IContext, lastSurveyDate: Date): AsyncResult<null> {
    const request = setLastSurveyDateInput(lastSurveyDate);
    return callActionOrExecute<null>(request, context.callerContext);
}
